import ApiService from '@/services/api.service';

const TestPanelSetupService = {
    getAllListing(parameters) {
        return ApiService.getWithArray('/PatientTestPanels/', parameters);
    },

    add(data) {
        return ApiService.post(`/PatientTestPanels`, data);
    },

    delete(id) {
        return ApiService.delete(`/PatientTestPanels/${id}`);
    },

    update(id, data) {
        return ApiService.put(`/PatientTestPanels/${id}`, data);
    },

    get(id) {
        return ApiService.get(`/PatientTestPanels/${id}`);
    },
};

export default TestPanelSetupService;
